module.exports = __webpack_public_path__ + "assets/img/202110-4W.1dbb9bcf.png";